import type { Sites } from '@studio/types';

type _Args = {
  formData: Pick<Sites.Components.FormInitialState, 'isPasscodeProtected' | 'passcode' | 'passcodeHelpText'>;
  isSupported: boolean;
};

/**
 * The passcode half of a site write, for both the POST and the PUT.
 *
 * `SitePUT` is a total write, so these are sent on every save and not only when the
 * control was touched — omit them from a rename and a restricted site becomes public.
 * `null` means "make this site public".
 *
 * The description is required whenever a code is set, so a protected site always carries
 * text here. Blank reaching this point is an upstream bug and the backend rejects it.
 */
const passcodeFields = ({ formData, isSupported }: _Args) => {
  if (!isSupported) return {};

  if (!formData.isPasscodeProtected) {
    return { passcode: null, passcodeHelpText: null };
  }

  return {
    passcode: formData.passcode,
    passcodeHelpText: formData.passcodeHelpText.trim(),
  };
};

export default passcodeFields;
